<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/purchase_return_record" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('IQCdanhao')">
						<el-input v-model="yt.conditions.no"></el-input>
					</el-form-item>
					<el-form-item :label="$t('caigoudingdanhao')">
						<el-input v-model="yt.conditions.orderNo"></el-input>
					</el-form-item>
					
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
					</el-form-item>
				</el-form>
			</template>
			
		
			
		</yi_curd_table>
		
		<!-- 导入excel -->
		<import-excel :show.sync="show" />
	</div>
</template>
<script type="text/javascript">
	// import importExcel from './import_excel'
	export default {
		name: 'web_supplier_portal_purchase_return_record_list',
		components: {
			// importExcel
		},
		data() {
			return {
				moveButton: true,
				currentRow: null,
				value: '',
				labelRuleDetailsVOList: [],
				multipleSelection: [],
				show: false,
				codeAndDesc: '',
				columns: [{
						label: 'IQCdanhao',
						prop: 'no',
						width: 180,
					}, {
						label: 'gongyingshangmingchen',
						prop: 'supplierName',
						width: 180,
					}, {
						label: 'gongyingshangdizhi',
						prop: 'address',
						width: 180,
					},
					{
						label: 'rukudingdanhanghao',
						width: 180,
						prop: 'rowNum'
					}, {
						label: 'caigoudingdanhao',
						prop: 'orderNo',
						width: 180,
					}, {
						label: 'caigoudingdanhanghao',
						prop: 'orderDetailNo',
						width: 180,
					}, {
						label: 'wuliaobianma',
						prop: 'materialCode',
						width: 180,
					}, {
						label: 'wuliaomingchen',
						prop: 'materialName',
						width: 180,
					}, {
						label: 'baojianshulian',
						prop: 'inspectionQuantity',
						width: 180,
					}, {
						label: 'tuihuoshuliang',
						prop: 'returnQuantity',
						width: 180,
					}, {
						label: 'jianyanyuan',
						prop: 'nickname',
						width: 180,
					}, {
						label: 'jianyanshijian',
						prop: 'inspection_time',
						width: 180,
					}, {
						label: 'beizhu',
						prop: 'remark',
						width: 180,
					}
				]
			};
		},
		created() {
			setTimeout(() => {
				console.log(this.yt.get(1))
				this.yt.get(1);
				
			}, 300)

		},
		methods: {
			
		},
	};
</script>